/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCobbAngle = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M22.242 3.97 10.59 6.882A9.954 9.954 0 0 1 12 12a9.96 9.96 0 0 1-1.407 5.117l11.65 2.913-.485 1.94-20-5 .484-1.94 6.299 1.575A7.958 7.958 0 0 0 10 12c0-1.716-.54-3.303-1.46-4.605L2.242 8.97l-.484-1.94 20-5z" />
        <path d="M6 13H4v-2h2z" />
      </g>
    </g>
  </Icon>
);
export { SvgCobbAngle as CobbAngle };
